/* eslint-disable no-sequences */
/* eslint-disable react/no-array-index-key */
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import transformContentHtml from "@insite/client-framework/Common/Utilities/transformContentHtml";
import { useShellContext } from "@insite/client-framework/Components/IsInShell";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonIcon, ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Icon from "@insite/mobius/Icon";
import Check from "@insite/mobius/Icons/Check";
import Img from "@insite/mobius/Img";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import CustomApplicationState from "@tCentro/Store/CustomApplicationState";
import { getPageLinkByPageType, useGetLink } from "@tCentro/Store/CustomLinksSelectors";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import parse from "html-react-parser";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface DivisionModal {
    fields: {
        slideTitle: string;
        description: string;
        optionalButtonLabel: string;
    };
}

const enum fields {
    slides = "slides",
    heading = "heading",
    image = "image",
    backgroundColor = "backgroundColor",
    mainHeadingDescriptionColor = "mainHeadingDescriptionColor",
    headingDescriptionColor = "headingDescriptionColor",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.backgroundColor]: string;
        [fields.slides]: DivisionModal[];
        [fields.heading]: string;
        [fields.mainHeadingDescriptionColor]: string;
        [fields.headingDescriptionColor]: string;
    };
}

export interface CENPunchoutWithCustomerStyles {
    container?: InjectableCss;
    heading?: InjectableCss;
    subTitle?: InjectableCss;
    quoteImageWrapper?: InjectableCss;
    checkIconStyles?: InjectableCss;
    imageWrapper?: InjectableCss;
    nextArrowButton?: ButtonPresentationProps;
    mainWrapper?: InjectableCss;
}

export const cenPunchoutWithCustomerStyles: CENPunchoutWithCustomerStyles = {
    heading: {
        css: css`
            font-size: ${TYPOGRAPHY.size.largest};
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            line-height: 32px;
            /* color: ${getProp("theme.typography.p.color")}; */
            display: inline-block;
            padding: 40px 20px 30px 40px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 32px 24px 0px 24px;
                    `,
                    css`
                        padding: 32px 24px 0px 24px;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    quoteImageWrapper: {
        css: css`
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 24px;
            padding-left: 40px;
            padding-bottom: 40px;
            padding-right: 40px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        grid-template-columns: repeat(1, 1fr);
                        padding: 24px 24px 32px 24px;
                    `,
                    css`
                        padding: 24px 24px 32px 24px;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    imageWrapper: {
        css: css`
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 3px;
        `,
    },
    subTitle: {
        css: css`
            font-weight: 600;
            font-size: 18px;
            line-height: 24px;
        `,
    },

    checkIconStyles: {
        css: css`
            color: ${getColor("primary")};
        `,
    },
    nextArrowButton: {
        // variant: "secondary",
        color: "text.main",
        css: css`
            border: 0;
            padding: 0;
            background: ${getColor("primary")};
            border-radius: 50%;
            position: relative;
            min-height: auto !important;
            width: 18px;
            height: 18px;
            top: 3px;
            /* span { */
            /* width: 100%;
                    height: 100%;
                    border-radius: 50%;
                } */
            svg {
                width: 12px;
                height: 28px;
                stroke: white;
                stroke-width: 4px;
                position: absolute;
                right: 9px;
                bottom: 2px;
            }
            &:focus {
                outline: none;
            }
            &:hover {
                background: ${getColor("primary")};
            }
        `,
    },
    mainWrapper: {
        css: css`
            display: flex;
            flex-direction: row;
        `,
    },
};

type Props = OwnProps;

const styles = cenPunchoutWithCustomerStyles;
const CENPunchoutWithCustomer: React.FC<Props> = ({ fields }) => {
    const description = {
        css: css`
            font-weight: 400;
            font-size: 16px;
            line-height: 24px;
            p {
                color: ${fields.mainHeadingDescriptionColor};
            }
        `,
    };
    const container = {
        css: css`
            background: ${fields.backgroundColor};
            margin-top: 64px;
            margin-bottom: 64px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: 32px;
                        margin-bottom: 32px;
                    `,
                    css`
                        margin-top: 32px;
                        margin-bottom: 32px;
                    `,
                    css`
                        margin-top: 40px;
                        margin-bottom: 40px;
                    `,
                    null,
                    null,
                ])}
        `,
    };

    return (
        <>
            <StyledWrapper {...container}>
                <Typography {...styles.heading} style={{ color: fields.mainHeadingDescriptionColor }}>
                    {fields.heading}
                </Typography>
                <StyledWrapper {...styles.quoteImageWrapper}>
                    {fields.slides?.map((slides: any) => {
                        const { url, title } = useGetLink(slides.fields.optionalButtonLink);
                        const history = useHistory();
                        const { isInShell } = useShellContext();
                        const onClick = () => {
                            if (!url) {
                                return;
                            }

                            if (url.startsWith("http")) {
                                if (isInShell) {
                                    return;
                                }

                                window.location.href = url;
                            } else {
                                history.push(url);
                            }
                        };
                        return (
                            <>
                                <StyledWrapper {...styles.mainWrapper}>
                                    <StyledWrapper {...styles.imageWrapper}>
                                        <Button {...styles.nextArrowButton} data-test-selector="nextBtn">
                                            <ButtonIcon src={Check} />
                                        </Button>
                                        {/* <ArrowRightIcon /> */}
                                    </StyledWrapper>
                                    <StyledWrapper>
                                        <StyledWrapper
                                            as="span"
                                            {...styles.subTitle}
                                            style={{ color: fields.headingDescriptionColor }}
                                        >
                                            {slides.fields.slideTitle}
                                        </StyledWrapper>
                                        <StyledWrapper {...description}>
                                            {parse(transformContentHtml(slides.fields.description), parserOptions)}
                                        </StyledWrapper>
                                    </StyledWrapper>
                                    {/* <Typography onClick={onClick}>{slides.fields.optionalButtonLabel || title || url}</Typography> */}
                                </StyledWrapper>
                            </>
                        );
                    })}
                </StyledWrapper>
            </StyledWrapper>
        </>
    );
};
const contentTab = {
    displayName: "Content",
    sortOrder: 0,
};

const widgetModule: WidgetModule = {
    component: CENPunchoutWithCustomer,
    definition: {
        group: "Common",
        displayName: "CEN Punchout With Customer",
        fieldDefinitions: [
            {
                name: fields.backgroundColor,
                editorTemplate: "ColorPickerField",
                displayName: "Background Color",
                defaultValue: "#EEF3F0",
                fieldType: "General",
            },
            {
                name: fields.heading,
                fieldType: "General",
                editorTemplate: "TextField",
                defaultValue: "",
            },
            {
                name: fields.mainHeadingDescriptionColor,
                editorTemplate: "ColorPickerField",
                displayName: "Main Heading Description Color",
                defaultValue: "#262525",
                fieldType: "General",
            },
            {
                name: fields.headingDescriptionColor,
                editorTemplate: "ColorPickerField",
                displayName: "Heading Description  Color",
                defaultValue: "#636161",
                fieldType: "General",
            },
            {
                name: fields.slides,
                editorTemplate: "ListField",
                tab: contentTab,
                getDisplay: (item: HasFields) => {
                    return item.fields.slideTitle;
                },
                defaultValue: [],
                fieldType: "Translatable",
                fieldDefinitions: [
                    {
                        name: "slideTitle",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },

                    {
                        name: "description",
                        editorTemplate: "RichTextField",
                        displayName: "Description",
                        defaultValue: "",
                    },
                ],
            },
        ],
    },
};

export default widgetModule;
